import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState, JobNoBoxReasonFacadeBase } from '@app/state';
import { JobNoBoxReason } from '@app/models';

@Injectable({ providedIn: 'root' })
export class JobNoBoxReasonFacade extends JobNoBoxReasonFacadeBase {
  constructor(private store: Store<AppState>) {
    super(JobNoBoxReason, store);
  }
}
